import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { UserProfileComponent } from './user-profile.component';
import { ToastModule } from 'primeng';

const routes: Routes = [{ path: '', component: UserProfileComponent, data: { title: 'Profile' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserProfileRoutingModule {}

@NgModule({
  imports: [
    UserProfileRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [UserProfileComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserProfileModule {}
